import { EventEmitter } from 'rxjs-event-emitter';

const eventEmitter = new EventEmitter();

export default eventEmitter;